<template>
  <div class="container">
    <div class="tip">
      <div class="title">
        账号登陆提示
      </div>
      <div class="message">
        当前登录账号不可用，您的超管账号为{{ adminAccount.login }} ，手机号为{{ adminAccount.mobileNo }}，请返回重新登录。
      </div>
      <div
        class="btn"
        @click="onClick"
      >
        返回
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { closePage } from '@/util/knb';

export default {
  name: 'ErrorAccount',
  computed: {
    ...mapState({ adminAccount: (state) => (state.adminAccount || {}) }),
  },
  methods: {
    onClick() {
      closePage();
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 75px;
  background: rgba(0, 0, 0, 0.18);
}
.tip {
  background: #ffffff;
  border-radius: 24px;
  padding: 48px 24px 36px;
}
.title {
  font-weight: 600;
  font-family: PingFangSC-Semibold;
  font-size: 36px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  line-height: 36px;
}
.message {
  margin: 24px 0 36px;
  font-weight: 400;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  line-height: 40px;
}
.btn {
  height: 88px;
  background: #ffcc33;
  border-radius: 44px;
  font-weight: 600;
  font-family: PingFangSC-Semibold;
  font-size: 28px;
  color: #333333;
  text-align: center;
  line-height: 88px;
}
</style>
